import React, { useState } from 'react';
import Login from '../Login/Login';
import { useConfig } from '../../../context/ConfigContext';

import './Auth.css';

import { Link as Anchor } from 'react-router-dom';
export default function Auth({ logo }) {
    const [showLogin, setShowLogin] = useState(true);
    const { storeSettings } = useConfig();

    console.log('Auth component - logo prop:', logo);

    const toggleComponent = () => {
        setShowLogin((prevShowLogin) => !prevShowLogin);
    };

    return (
        <div className='AuthContainer'>
            <Anchor to={`/`} >
                <img 
                    src={logo} 
                    alt="Efecto Vial" 
                    className={`logoAtuh ${storeSettings.logoType === 'rectangle' ? 'logo-rectangle' : 'logo-circle'}`}
                />
            </Anchor>

            <Login />


        </div>
    );
}
